import { useLingui } from '@lingui/react/macro';

import { Endpoints } from '@/api';

export const useGetExchangeTypes = (): {
  exchangeTypeOptions: {
    value: NonNullable<Endpoints['PATCH /articles/:id/exchange']['body']['type']>;
    label: string;
  }[];
} => {
  const { t } = useLingui();

  return {
    exchangeTypeOptions: [
      {
        value: 'refurbishment',
        label: t({
          id: 'service-choice.exchange.exchange-type.refurbishment',
          message: 'Refurbishment with remanufacturing option',
        }),
      },
      {
        value: 'remanufacturing',
        label: t({
          id: 'service-choice.exchange.exchange-type.remanufacturing',
          message: 'Remanufacturing',
        }),
      },
      {
        value: 'replacement',
        label: t({
          id: 'service-choice.exchange.exchange-type.replacement',
          message: 'Standard exchange',
        }),
      },
    ],
  };
};
